import { axios as _axios } from "@integration/axios/csr";

export const axios = _axios.create({
  baseURL: "/api/account",
});
